<template>
  <v-app>
    <v-content>
      <router-view
        v-if="canShowRouterView" />
      <div
        v-else
        class="initial-app-loader">
        <v-progress-circular
          v-if="isLoadingInitialRequests"
          color="primary"
          indeterminate />
        <div>
          <span
            v-if="loadingErrorMessage">
            {{ loadingErrorMessage }}
          </span>
          <span
            v-else>
            Lade Daten ...
          </span>
        </div>
        <v-btn
          v-if="loadingErrorMessage"
          @click="performInitialRequests">
          Erneut versuchen
        </v-btn>
      </div>
    </v-content>
  </v-app>
</template>

<script>
import BL from '@/bl/bl'
import Themer from '@/themes/themer'

export default {
  name: 'App',

  created () {
    this.performInitialRequests()
    Themer.setTheme(this.$vuetify, 'vivantes')
  },

  data: () => ({
    isLoadingInitialRequests: false,
    loadingErrorMessage: void 0,
    canShowRouterView: false
  }),

  methods: {
    performInitialRequests () {
      this.loadingErrorMessage = void 0
      this.isLoadingInitialRequests = true

      BL.requestEssential()
        .then(_ => {
          this.canShowRouterView = true
          this.$router.replace({
            name: 'Home'
          })
            .catch(err => err)
        })
        .catch(_ => {
          this.loadingErrorMessage = 'Fehler beim Laden der Daten.'
        })
        .finally(_ => {
          this.isLoadingInitialRequests = false
        })
    }
  }
}
</script>

<style lang="scss">
  html,
  body {
    width: 100%;
    height: auto;
  }

  .corporate-color-bar {
    width: 100%;
    height: 8px;
    flex: 0 0 8px;
    display: block;
    background-color: #cc0033;
  }

  .initial-app-loader {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  // Override outlined v-input border-color

  .v-input.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
    color: rgba(0, 0, 0, 0.15);
  }

  html, body {
    overflow: auto!important;
  }
</style>
